var map = {
	"./Clouds_1.png": 1139,
	"./Clouds_2.png": 6479,
	"./Clouds_3.png": 5561,
	"./Clouds_4.png": 7212,
	"./Clouds_5.png": 9122,
	"./Clouds_6.png": 8882
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6717;